/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbRechercheExportGapDto
 */
export interface FcbRechercheExportGapDto {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheExportGapDto
     */
    idexport?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbRechercheExportGapDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbRechercheExportGapDto
     */
    centre?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbRechercheExportGapDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbRechercheExportGapDto
     */
    valide?: boolean | null;
}

/**
 * Check if a given object implements the FcbRechercheExportGapDto interface.
 */
export function instanceOfFcbRechercheExportGapDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheExportGapDtoFromJSON(json: any): FcbRechercheExportGapDto {
    return FcbRechercheExportGapDtoFromJSONTyped(json, false);
}

export function FcbRechercheExportGapDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheExportGapDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexport': !exists(json, 'idexport') ? undefined : json['idexport'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'valide': !exists(json, 'valide') ? undefined : json['valide'],
    };
}

export function FcbRechercheExportGapDtoToJSON(value?: FcbRechercheExportGapDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexport': value.idexport,
        'date': value.date,
        'centre': value.centre,
        'description': value.description,
        'valide': value.valide,
    };
}

